jump<template>
	<div class="hear-menu-main">
		<!-- 头栏内容 -->
		<ul class="hear-menu-warp box" :class="[menuBg,addVertical]">
			<li class="box menu-left relative">
				<div class="menu-logo"></div>
				<a href="/" class="jump-warp"></a>
			</li>
			<li class="box menu-right" v-if="subscribe">
				<div class="sign-warp relative sign-warp-btn-hide" :class="{'show':!customerInfo.userID}">
					<span class="sign-btn">
						<a href="/user/sign.html" :class="[addVertical]" @click="setFree()">登录</a>
						<a href="/user/register.html" class="sign-btn-warming" :class="[addVertical]">注册</a>
					</span>
				</div>
				<div class="sign-warp sign-warp-btn-hide" @click="changeUserOperation()" :class="{'show':customerInfo.userID}">
					<!-- <i class="iconfont icon-person"></i> -->
					<span class="sign-btn-admin" :class="[addVertical]">管理</span>
				</div>
				<div class="sign-warp sign-warp-menu-btn" @click="changeUserDoc()">
					<i class="iconfont icon-menu icon-menu-css"></i> 菜单
				</div>
			</li>
		</ul>

		<!-- 用户弹框 -->
		<mt-popup v-model="hearMenuMessage" position="right">
			<div class="child-menu flex" @click.stop>
				<ul class="user-warp">
					<li class="user-img relative">
						<a href="/user/message.html" class="jump-warp"></a>
					</li>
					<li :class="{'hide':!customerInfo.userID}">
						<ul>
							<li class="user-status btn-outline-warming" :class="{'hide':customerInfo.level != 'silver'}">普通会员</li>
							<li class="user-status btn-outline-deep-warming" :class="{'hide':customerInfo.level != 'gold'}">VIP客户</li>
							<li class="user-status btn-outline-primary" :class="{'hide':customerInfo.level != 'civilian'}">推广专员</li>
							<li class="user-status btn-outline-success" :class="{'hide':customerInfo.level != 'bronze'}">渠道代理</li>
							<li class="user-name">{{customerInfo.email}}</li>
							<li class="text-success" :class="{'hide':customerInfo.realNameVerify !== 1 }">
								<i class="iconfont icon-success"></i> 已实名认证
							</li>
							<li class="text-deep-warming" :class="{'hide':customerInfo.realNameVerify === 1 }">
								<i class="iconfont"></i> 未实名认证
							</li>
						</ul>
					</li>
				</ul>
				<ul class="user-title-warp box">
					<li>
						余额：<span class="user-money text-deep-warming">￥{{customerInfo.money}}</span>
					</li>
					<li class="btn btn-deep-warming relative" :class="[addVertical]">
						充值
						<a href="/user/recharge.html" class="jump-warp"></a>
					</li>
				</ul>
				<ul class="user-operation-warp box">
					<li class="user-operation-item flex">
						<div>
							<i class="iconfont icon-moneyrecord user-operation-infont"></i>
						</div>
						<div class="user-operation-title relative">
							资金记录
							<a href="/user/capital.html" class="jump-warp"></a>
						</div>
					</li>
					<li class="user-operation-item flex">
						<div>
							<i class="iconfont icon-daijinquan user-operation-infont"></i>
						</div>
						<div class="user-operation-title relative">
							代金券管理
							<a href="/user/coupon.html" class="jump-warp"></a>
						</div>
					</li>
				</ul>
				<ul class="user-operation-warp box">
					<li class="user-operation-item flex">
						<div>
							<i class="iconfont icon-zifei user-operation-infont"></i>
						</div>
						<div class="user-operation-title relative">
							资费记录
							<a href="/user/postage.html" class="jump-warp"></a>
						</div>
					</li>
					<li class="user-operation-item flex">
						<div>
							<i class="iconfont icon-yajin user-operation-infont"></i>
						</div>
						<div class="user-operation-title relative">
							押金记录
							<a href="/user/deposit.html" class="jump-warp"></a>
						</div>
					</li>
				</ul>
				<div class="user-title-warp other-top">
					其他服务
				</div>
				<ul class="user-operation-warp box">
					<li class="user-operation-item flex">
						<div>
							<i class="iconfont icon-config user-operation-infont"></i>
						</div>
						<div class="user-operation-title relative">
							资源管理
							<a href="/user/resources.html" class="jump-warp"></a>
						</div>
					</li>
					<li class="user-operation-item flex relative">
						<div>
							<i class="iconfont icon-info1 user-operation-infont"></i>
						</div>
						<div class="user-operation-title relative">
							站内消息
							<a href="/user/stationnew.html" class="jump-warp"></a>
						</div>
						<div class="user-msg" v-if="message > 0">{{message > 99 ? '99+' : message}}</div>
					</li>
				</ul>
				<ul class="user-title-warp box menu-footer-warp">
					<li class="flex footer-item footer-item-left relative">
						<i class="iconfont icon-home"></i> 首页
						<a href="/" class="jump-warp"></a>
					</li>
					<li class="flex footer-item footer-item-right" @click="unSign()">
						<i class="iconfont icon-signOut"></i> 退出登录
					</li>
				</ul>
			</div>
		</mt-popup>

		<!-- 菜单弹框 -->
		<mt-popup v-model="hearMenuDoc" id="menu-doc" position="right">
			<ul class="child-menu flex">
				<li class="user-title-warp title-close-warp" @click="hideUserDoc()">
					<i class="iconfont icon-error"></i> 关闭
				</li>
				<li class="title-main">
					<ul>
						<li class="user-title-warp">
							<i class="iconfont icon-home"></i> 首页
							<a href="/" class="jump-warp"></a>
						</li>
						<!-- <li class="user-title-warp box space-between">
							<div>
								<i class="iconfont icon-gift"></i> 最新活动
							</div>
							<div class="text-muted">
								<span class="text-danger user-spot">●</span> 优惠多多
							</div>
						</li> -->
						<!-- <li class="user-title-warp box space-between">
							<div>
								<i class="iconfont icon-news"></i> 产品动态
							</div>
							<div class="text-muted">
								<span class="text-danger user-spot">●</span> 有新消息
							</div>
						</li> -->
						<li class="user-title-warp box" @click="dataScondSwitch('productSecondShow')">
							<div><i class="iconfont icon-server"></i> 产品与服务</div>
							<i class="iconfont" :class="{'icon-right':!secondShow.productSecondShow,'icon-dowm':secondShow.productSecondShow}"></i>
						</li>
						<li class="user-second-warp box product-second-warp" :class="{'hide-second':!secondShow.productSecondShow}">
							<div class="user-second-item btn relative" v-for="item in productSecondData">
								{{item.title}}
								<a :href="item.hrefName" class="jump-warp"></a>
							</div>
						</li>
						<li class="user-title-warp box" @click="dataScondSwitch('solveSecondShow')">
							<div><i class="iconfont icon-solution"></i> 解决方案</div>
							<i class="iconfont" :class="{'icon-right':!secondShow.solveSecondShow,'icon-dowm':secondShow.solveSecondShow}"></i>
						</li>
						<li class="user-second-warp box solve-second-warp" :class="{'hide-second':!secondShow.solveSecondShow}">
							<div class="user-second-item btn relative" v-for="item in solveSecondData">
								{{item.title}}
								<a :href="item.hrefName" class="jump-warp"></a>
							</div>
						</li>
						<li class="user-title-warp box" @click="dataScondSwitch('dataSecondShow')">
							<div>
								<i class="iconfont icon-datacenter"></i> 云数据中心
							</div>
							<i class="iconfont" :class="{'icon-right':!secondShow.dataSecondShow,'icon-dowm':secondShow.dataSecondShow}"></i>
						</li>
						<li class="user-second-warp box" :class="{'hide-second':!secondShow.dataSecondShow}">
							<div class="user-second-item btn relative" v-for="item in dataSecondData">
								{{item.title}}
								<a :href="item.hrefName" class="jump-warp"></a>
							</div>
						</li>
						<!-- <li class="user-title-warp">
							<i class="iconfont icon-coo"></i> 渠道与合作
							<a href="/other/cooperation.html" class="jump-warp"></a>
						</li> -->
						<li class="user-title-warp">
							<i class="iconfont icon-about1"></i> 关于睿江云
							<a href="/other/aboutUs.html" class="jump-warp"></a>
						</li>
						<!-- <li class="user-title-warp">
							<i class="iconfont icon-handbook"></i> 小程序手册
						</li> -->
						<li class="doc-footer-warp" :class="{'hide':customerInfo.userID}">
							<div class="user-title-register btn-primary">
								登录
								<a href="/user/sign.html" class="jump-warp"></a>
							</div>
							<div class="user-title-register sign-btn-warming">
								免费注册会员
								<a href="/user/register.html" class="jump-warp"></a>
							</div>
						</li>
					</ul>
				</li>
			</ul>
		</mt-popup>
	</div>
</template>

<script>
import { common } from '../../common/js/common.js'
import { service } from '../../common/service/service.js'
import { pxToRem } from '../../common/js/pxToRem.js'
import { Popup } from 'mint-ui'

export default {
	props: {
		subscribe: {
			type: Boolean,
	 		default: true,
		}
  	},
	data () {
		return {
			menuBg: '',  // 是否显示背景色
			showBgPage:['/module/index.html','/','product','solve','data','/other/cooperation.html'], // 不显示导航背景的页面  绝对路径
			addVertical:'',  //垂直居中
			// 用户相关数据
			hearMenuMessage:false,
			customerInfo:{},

			// 站内消息
			message: 0,

			// 文档菜单相关数据控制
			hearMenuDoc:false,
			secondShow:{
				productSecondShow:false,
				dataSecondShow:false,
				solveSecondShow:false,
			},
			productSecondData:[
				{title:'云服务器',hrefName:'/product/cloud.html'},
				{title:'云磁盘存储',hrefName:'/product/disk.html'},
				{title:'云快照备份',hrefName:'/product/snapshot.html'},
				{title:'镜像服务',hrefName:'/product/mirror.html'},
				{title:'VPC虚拟私有云',hrefName:'/product/vpc.html'},
				{title:'弹性公网IP',hrefName:'/product/eip.html'},
				{title:'NAT网关',hrefName:'/product/nat.html'},
				{title:'共享带宽包',hrefName:'/product/shareband.html'},
				{title:'SLB负载均衡',hrefName:'/product/slb.html'},
				{title:'智能云解析',hrefName:'/product/dns.html'},
				// {title:'Web应用防火墙',hrefName:'/product/waf.html'},
				{title:'云高防',hrefName:'/product/safe.html'},
				{title:'IDC服务器托管',hrefName:'/product/idc.html'},
				{title:'IDC服务器租赁',hrefName:'/product/idcLease.html'},
				{title:'BGP网络接入',hrefName:'/product/bgp.html'},
				{title:'大带宽接入',hrefName:'/product/bandwidth.html'},
				{title:'专属云',hrefName:'/product/exclusive.html'},
				{title:'私有云',hrefName:'/product/private.html'},
			],
			solveSecondData:[
				{title:'电商解决方案',hrefName:'/solve/commerce.html'},
				{title:'游戏解决方案',hrefName:'/solve/game.html'},
				{title:'APP解决方案',hrefName:'/solve/app.html'},
				{title:'视频解决方案',hrefName:'/solve/video.html'},
				{title:'网站解决方案',hrefName:'/solve/web.html'},
				{title:'政企解决方案',hrefName:'/solve/government.html'},
				{title:'容灾双活解决方案',hrefName:'/solve/recovery.html'},
                {title:'教育解决方案',hrefName:'/solve/education.html'},
                {title:'数据管控解决方案',hrefName:'/solve/data-control.html'},
                {title:'行为管控解决方案',hrefName:'/solve/behavior-control.html'},
                {title:'IT成本优化解决方案',hrefName:'/solve/it-cost.html'},
                {title:'IT架构融合解决方案',hrefName:'/solve/it-architecture-fusion.html'},
                {title:'视频渲染解决方案',hrefName:'/solve/video-renderer.html'},
                {title:'超融合灾备解决方案',hrefName:'/solve/hyper-converged-dr.html'},
			],
			dataSecondData:[
				{title:'华南地区',hrefName:'/data/huaNan.html'},
				{title:'华东地区',hrefName:'/data/huaDong.html'},
				{title:'华北地区',hrefName:'/data/huaBei.html'},
				// {title:'香港地区',hrefName:'/data/hongKong.html'},
			],
			props: {
				isSubscribe: String,
			},
			handler:function(e){e.preventDefault();}
		}
	},
	methods:{
		/**
		 * Description:设置头栏透明或黑色背景
		 * @param [scrollTop] 滚动值非0显示黑色
		 * @value [menu-bg-show] 黑色背景
		 */
		judgeTopBg(scrollTop){
			if(scrollTop!=0){
				this.menuBg = 'menu-bg-show';
			}else{
				this.menuBg = '';
			}
			if(this.pageIndex<0){
				this.menuBg = 'menu-bg-show';
				return;
			}
		},

		/**
		 * Description:创建时候判断是否显示背景
		 */
		judgeTopBgCreate(){
			let urlPath = window.location.pathname;
			this.pageIndex = this.showBgPage.indexOf(urlPath);

			let urlArr = urlPath.split("/");
			if(urlArr.length > 1 && this.pageIndex < 0){
				this.pageIndex = this.showBgPage.indexOf(urlArr[1]);
			}

			if(!urlPath){
				this.pageIndex = 1;
			}
			this.judgeTopBg(0);
		},

		/**
		 * Description:显示用户管理
		 */
		changeUserOperation(){
			this.hearMenuMessage = true;
			this.judgeTopBg(100);
		},

		/**
		 * Description:显示文档
		 */
		changeUserDoc(){
			this.hearMenuDoc = true;
			this.judgeTopBg(100);
			this.dataScondSwitch('tex');
		},
		hideUserDoc(){
			this.hearMenuDoc = false;
		},

		/**
		 * Description:菜单的二级子菜单是否展开
		 * @param [tex:string] 展开的对象项
		 */
		dataScondSwitch(tex){
			let secondShow = this.secondShow;
			Object.keys(secondShow).forEach(function(key){
				secondShow[key] = key==tex?!secondShow[key]:false;
			});
			this.secondShow = secondShow;
		},

		setFree: function(){
			if(window.location.pathname === '/active/free.html'){
				common.setCookies('jump','/active/free.html',7);
			}
		},




		/*###############  以下是处理接口  ###############*/
		/**
		 * Description:获取用户信息
		 */
		getUserMessage(){
			let interfaceName = 'cloudPlatform/QueryCustomerInfo';
			service.interfaceUrl(interfaceName,{},'all',this.getUserMessageSuccess,this.getUserMessageError)
		},

		/**
		 * Description:获取用户信息成功
		 * @param [res] 返回数据
		 */
		getUserMessageSuccess(res){
			this.customerInfo = res.data;
			this.getUserMoney();
			this.getMessage();

			// 存储邮箱，方便免费活动获取
			common.setCookies('email',this.customerInfo.email,7);
		},

		/**
		 * Description:获取用户信息失败
		 * @param [res] 返回数据
		 */
		getUserMessageError(res){
			this.customerInfo = {};
		},


		/**
		 * Description:获取用户资金
		 */
		getUserMoney(){
			let interfaceName = 'cloudPlatform/GetUserBalance';
			service.interfaceUrl(interfaceName,{},'all',this.getUserMoneySuccess,this.getUserMoneySuccess)
		},
		getUserMoneySuccess(res){
			if(res && res.data){
				this.customerInfo.money = common.addNumber(res.data.cashMoney,res.data.couponMoney);
			}
		},


		/**
		 * Description:获取站内信息
		 */
		getMessage(){
			let interfaceName = 'message/QueryMessageByMultipleParam';
			let param = {
				limitStart: 0,
				limitCount: 4,
				isread: 0
			}
			service.interfaceUrl(interfaceName,param,'all',this.getMessageSuccess)
		},
		getMessageSuccess(res){
			this.message = res.data.count;
		},


		/**
		 * Description: 退出登录
		 */
		unSign(){
			let interfaceName = 'cloudPlatform/Logout';
			let token = common.getCookies('__ecfToken');
			let parameter = {
				tokenUUID : token
			}
			service.interfaceUrl(interfaceName,parameter,'all',this.unSignSuccess);
		},
		unSignSuccess(){
			common.delete('__ecfToken');
			common.delete('userID');
			this.goToSign();
		},
		goToSign(){
			common.jumpSign();
		},


		/**
		 * Description:获取到from参数
		 */
		getFromPar(){
			let from = common.getParforUrl('from');
			if(from){
				common.setCookies('from',from);
			}
		},
		/**
		 * Description:获取到sourceUrl
		 */
		getSourceUrl(){
			let sourceUrl = common.getParforUrl('sourceUrl');
			let lostUrl =  sourceUrl || document.referrer;
			let nowUrl = window.location.host;
			if (!!lostUrl && lostUrl.indexOf(nowUrl) === -1 && lostUrl.indexOf('eflycloud') === -1) {
				common.setCookies('sourceUrl',lostUrl,30);
			}
		},
		/*###############  处理接口结束  ###############*/



		/*###############  事件处理  ###############*/
		/**
		 * Description:屏幕滚动
		 */
		windowScroll(){
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			this.judgeTopBg(scrollTop);
		},

		/**
		 * Description:弹框后阻止屏幕滚动
		 */
		closeTouch:function(){
			document.getElementsByTagName("body")[0].addEventListener('touchmove',
				this.handler,{passive:false});//阻止默认事件

		},
		openTouch:function(){
			let oThis = this;
			document.getElementsByTagName("body")[0].removeEventListener('touchmove',
				this.handler,{passive:true});//打开默认事件
		},
	},
	mounted () {
		window.addEventListener('scroll', this.windowScroll);
		//检测是否是安卓机
		var u = navigator.userAgent;
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
		this.addVertical = isAndroid ? 'vertical-center' : '';
	},
	beforeCreate:function(){
		pxToRem();
		if(common.judgeBaiduStatistics()){
			// 百度代码 - 第一次
			if(window.location.host == 'm.eflycloud.com'){
				var _hmt = _hmt || [];
				(function() {
				  var hm = document.createElement("script");
				  hm.src = "https://hm.baidu.com/hm.js?3dfbd11546977320370cd51be7c3a56e";
				  var s = document.getElementsByTagName("script")[0];
				  s.parentNode.insertBefore(hm, s);
				})();
			}
			// 基础代码
			if(window.location.host == 'm.eflycloud.com'){
				window._agl = window._agl || [];
				(function () {
					_agl.push(
						['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
					);
					(function () {
						var agl = document.createElement('script');
						agl.type = 'text/javascript';
						agl.async = true;
						agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
						var s = document.getElementsByTagName('script')[0];
						s.parentNode.insertBefore(agl, s);
					})();
				})();
			}
			// 百度代码 - 第二次
			if(window.location.host === 'm.eflycloud.com'){
				var _hmt = _hmt || [];
				var hm = document.createElement("script");
				hm.src = "https://hm.baidu.com/hm.js?dbb161b0ac3a4d9e49fe7aa9d5689ea7";
				var s = document.getElementsByTagName("script")[0];
				s.parentNode.insertBefore(hm, s);
			}
		}
	},
	created: function () {
		var isLogin = common.getCookies('userID');
		if(isLogin && isLogin != 'RJ_VISITOR'){
			this.customerInfo.userID = isLogin;
			this.getUserMessage();
		}
		this.judgeTopBgCreate();
		common.promotersIDCookies();
		this.getFromPar();
		this.getSourceUrl();
	},
	watch:{
		/**
		 * Description:监听菜单
		 */
		hearMenuMessage:function(val){
			if(val){
				this.closeTouch();//关闭默认事件
			}else{
				this.openTouch();//打开默认事件
			}
		},

		/**
		 * Description:监听用户管理
		 */
		hearMenuDoc:function(val){
			this.openTouch();//打开默认事件
		}
	},
	computed: { }
}
</script>

<style>
	@import 'hearMenu.css';
</style>



// WEBPACK FOOTER //
// hearMenu.vue?e7cf4720